import t from "@ext/localization/locale/translate";
import { ConfirmPopover } from "@ui-kit/ConfirmPopover";

export type DiscardConfirmProps = {
	children: JSX.Element;
	count: number;
	onConfirm: () => Promise<unknown>;
	onOpenChange: (open: boolean) => void;
};

export const DiscardConfirm = ({ children, count, onConfirm, onOpenChange }: DiscardConfirmProps) => (
	<ConfirmPopover
		cancelText={t("git.discard.alert.buttons.secondary")}
		confirmText={t("git.discard.alert.buttons.primary").replace("{count}", count > 1 ? ` (${count})` : "")}
		description={t("git.discard.alert.body")}
		icon="triangle-alert"
		onConfirm={onConfirm}
		onOpenChange={onOpenChange}
		status="error"
		title={t("git.discard.alert.title")}
	>
		{children}
	</ConfirmPopover>
);
